import { SeriesName } from '@/types/meters'

export const seriesColor: Partial<Record<SeriesName, string>> = {
    heat_ratio: '#FF5733',
    cool_ratio: '#33C1FF',
}
